export function sameDates(data1: Date, data2: Date) {
  return (
    data1.getFullYear() === data2.getFullYear() &&
    data1.getMonth() === data2.getMonth() &&
    data1.getHours() === data2.getHours() &&
    data1.getMinutes() === data2.getMinutes()
  )
}
